module.exports = __webpack_public_path__ + "static/media/Bayswater Ave Burlingame, CA4.c918c63b.jpg";